/* eslint-disable consistent-return */
import { useEffect } from "react";

import { useSearchParams, useRouter, usePathname } from "next/navigation";

import { AuthStore } from "@packages/store/models/AuthStore";

import { ROUTES } from "@/routes";

export const useTokenCheck = (auth: AuthStore | undefined) => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    const { loginByToken } = auth ?? {};

    const removeSearchParam = (param: string) => {
      const params = new URLSearchParams(searchParams.toString());
      params.delete(param);
      router.replace(`${pathname}?${params.toString()}`);
    };

    const fn = async () => {
      const token = searchParams.get("token");

      if (token && loginByToken) {
        removeSearchParam("token");

        await loginByToken(token);

        router.replace(ROUTES.SETUP_PASSWORD);
      }
    };

    fn();
  }, [auth, pathname, router, searchParams]);
};
